import { db } from '@/services/firebase'

export function getNewKey(child: string) {
  return db.ref().child(child).push().key
}
